module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-13-a88cb3097dd1de33998af74e725e7794.jpg";